<template>
  <div class="lyric_search">
    <div class="othen_search">
      <div class="date_search">
        <div class="item_title">Please select time:</div>
        <el-date-picker
          @blur="getStartDate"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsStart"
          placeholder="Start date"
          v-model="startDate"
        ></el-date-picker>
        <span class="to_txt">&nbsp;&nbsp;to&nbsp;&nbsp;</span>
        <el-date-picker
          @blur="getEndDate"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsEnd"
          placeholder="End date"
          v-model="endDate"
        ></el-date-picker>
      </div>
      <div class="news_source">
        <div class="item_title">News source:</div>
        <el-select
          v-model="newsVal"
          clearable
          filterable
          placeholder="Source site"
          @change="handleSelect"
        >
          <el-option
            v-for="(item, i) in options"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <!-- 国家筛选 -->
      <div class="news_source">
        <div class="item_title">Country:</div>
        <el-select
          v-model="countryValue"
          filterable
          placeholder="Please Country"
          @change="handleCountry"
          clearable
        >
          <el-option
            v-for="item in countryList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 新闻搜索 -->
      <div class="search">
        <el-input
          placeholder="Search Keywords"
          v-model="searchVal"
          class="input_style"
        >
          <el-button
            @click="search"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </div>
    </div>
    <div class="data_list" v-if="newsData && newsData.length > 0">
      <div class="news" v-for="(item, index) of newsData" :key="index">
        <div class="news_img">
          <div class="img_container">
            <img :src="item.cover" @error="defaultImg(item)" />
          </div>
        </div>
        <div class="news_content">
          <!-- 点击标题跳转详情 -->
          <div
            class="title text_one_line"
            @click="newContentDetail(item.id)"
            v-html="item.title"
          >
            {{ item.title }}
          </div>
          <div class="detail text_two_line" v-html="item.summary">
            {{ item.summary }}
          </div>
          <div class="other_infor">
            <div class="new_from">
              <span class="item_title">Source:</span>
              <span class="item_detail color_alone">
                {{ item.source }}
                <el-divider direction="vertical"></el-divider>
              </span>
            </div>
            <div class="new_author" v-if="item.author !== null">
              <span class="item_title">Author:</span>
              <span class="item_detail">
                {{ item.author }}
                <el-divider direction="vertical"></el-divider>
              </span>
            </div>
            <div class="new_time">
              <span class="item_title">Release time:</span>
              <span class="item_detail">{{ item.publish }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 分页  -->
      <el-pagination
        background
        layout="total,prev, pager, next"
        :total="totalNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <div v-else>
      <div class="no_data">
        <img :src="noDataImgUrl" alt />
        <div class="no_data_txt">No search results yet</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  overseasPublic,
  newsID,
  getHomeCountry,
} from "@/common/js/http/version3Api.js";
import qs from "qs";

export default {
  name: "LyricSearch",
  props: ["companyIfor"],
  data() {
    return {
      restaurants: [],
      state1: "",
      currentPage: 1,
      pageSize: 5,
      totalNum: 0, //总页数为100
      entryKeyword: false,
      entryNews: false,
      entryStart: false,
      entryEnd: false,
      companyID: this.$route.query.id,
      searchVal: "",
      newsVal: "",
      startDate: null,
      endDate: null,
      options: [],
      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.startDate;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
      noDataImgUrl: require("../../../../../assets/images/other_icon/empty.png"),
      newsData: [],
      countryList: [],
      countryValue: "",
    };
  },
  created() {
    sessionStorage.setItem("detail", true);
    if (this.$route.query.time) {
      const quarter = this.$route.query.time.split("-")[1].slice(0, -1);
      if (quarter === " Q") {
        this.$message({
          type: "warning",
          message: "This operation is not supported !",
        });
      }
    }

    const dataForm = /^(\d{4})-(\d{2})-(\d{2})$/;
    if (dataForm.test(this.$route.query.time)) {
      this.startDate = this.$route.query.time;
      this.endDate = this.$route.query.time;
    } else {
      if (
        this.$route.query.time === undefined &&
        sessionStorage.getItem("month") == null
      ) {
        this.startDate = null;
        this.endDate = null;
      } else {
        if (dataForm.test(sessionStorage.getItem("month"))) {
          this.startDate = sessionStorage.getItem("month");
          this.endDate = sessionStorage.getItem("month");
        } else {
          var date = new Date(sessionStorage.getItem("month"));
          var nowYear = date.getFullYear();
          var nowMonth = date.getMonth();
          //本月的开始时间
          var monthStartDate = new Date(nowYear, nowMonth, 1);
          //本月的结束时间
          var monthEndDate = new Date(nowYear, nowMonth + 1, 0);
          const start = new Date(monthStartDate);
          const startDate =
            start.getFullYear() +
            "-" +
            (start.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            start
              .getDate()
              .toString()
              .padStart(2, "0");
          const end = new Date(monthEndDate);
          const endDate =
            end.getFullYear() +
            "-" +
            (end.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            end
              .getDate()
              .toString()
              .padStart(2, "0");
          this.startDate = startDate;
          this.endDate = endDate;
        }
      }
    }
    this.startSearch();
    this.getNewsid();
    this.getCountry();
  },
  mounted() {
    this.getSchoolWebModuleMessageListFunc();
  },

  methods: {
    defaultImg(item) {
      if (this.companyIfor.length > 0) {
        item.cover = this.companyIfor[0].logoPath;
      }
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    // 顶部搜索
    search() {
      this.entryKeyword = true;
      this.startSearch();
    },
    // 新闻来源搜索
    handleSelect(item) {
      this.newsVal = item;
      this.currentPage = 1;
      this.startSearch();
    },
    //国家搜索
    handleCountry(val) {
      this.countryValue = val;
      this.currentPage = 1;
      this.startSearch();
    },
    getStartDate() {
      this.entryStart = true;
      this.startSearch();
    },
    getEndDate() {
      this.entryEnd = true;
      this.startSearch();
    },
    async getNewsid() {
      let res = await newsID({ companyId: this.$route.query.id });
      this.options = res.result;
    },
    async getCountry() {
      const { result } = await getHomeCountry();
      this.countryList = result;
    },
    // 新闻详情
    newContentDetail(id) {
      this.$router.push({
        name: "ArticleDetails",
        query: {
          id: id,
        },
      });
    },
    async startSearch() {
      let data = {
        companyId: this.companyID, //新闻所属企业ID
        countryName: this.countryValue, //国家名称
        currentPage: sessionStorage.getItem("currentPage")
          ? sessionStorage.getItem("currentPage")
          : this.currentPage, //当前页
        pageSize: this.pageSize, //每页条数
        keyWords: this.searchVal, //搜索关键词
        sourceId: this.newsVal, //新闻来源ID
        startTime: this.startDate,
        endTime: this.endDate,
        brandToken: localStorage.getItem("brand-token"),
      };
      let res = await overseasPublic(qs.stringify(data));
      this.newsData = res.result.list;
      this.totalNum = res.result.totalElements;
    },
    //分页显示
    handleSizeChange(val) {
      this.pageSize = val; //动态改变
      //this.startSearch()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      sessionStorage.setItem("currentPage", val);
      this.startSearch();
    },
    getSchoolWebModuleMessageListFunc() {
      // console.log(sessionStorage.getItem('id'));
      if (this.$route.query.id === sessionStorage.getItem("id")) {
        //当从详情页返回的时候，先获取详情页中存下来的detall标识，在列表页中，把获取到的分页页码重新赋值赋值，用以返回前的页面，保持不变
        if (sessionStorage.getItem("detail")) {
          // console.log(Number(sessionStorage.getItem("currentPage")));
          //如果有这个就读取缓存里面的数据
          this.pageSize = 5;
          //this.pageSize = Number(sessionStorage.getItem("currentPage"));
          this.currentPage = Number(sessionStorage.getItem("currentPage"));
        } else {
          this.pageSize = 5;
          //这个主要是从其他页面第一次进入列表页，清掉缓存里面的数据
          sessionStorage.removeItem("currentPage");
        }
      } else return;
    },
  },
  destroyed() {
    sessionStorage.removeItem("detail");
  },
  watch: {
    companyIfor: {
      handler(val) {
        this.companyIfor = val;
      },
      deep: true,
    },
    endDate() {
      if (this.endDate == null) {
        this.startSearch();
      }
    },
    startDate() {
      if (this.startDate == null) {
        this.startSearch();
      }
    },
  },
};
</script>

<style scoped>
.lyric_search {
  position: relative;
}

.no_data {
  margin-top: 95px;
  text-align: center;
}

.no_data .no_data_txt {
  font-size: 14px;
  color: #4e5671;
  margin-top: 15px;
}

.no_data img {
  width: 200px;
}

.search {
  width: 20%;
  margin-top: 5px;
}

.search >>> .el-input-group__append .el-icon-search {
  font-size: 20px;
  font-weight: bold;
}

.search >>> .el-input-group__append {
  border: 0;
  background: transparent;
}

.search >>> .el-input__inner {
  border: 0;
  background: transparent;
}

.search >>> .input_style {
  border-radius: 40px;
  background: #f2f3f4;
  border: 1px solid #e2e3e4;
}

.othen_search {
  margin: 5px 0 0;
}

.othen_search > div {
  display: inline-block;
  margin-right: 24px;
}

.to_txt {
  font-size: 14px;
  color: #4e5671;
}

.date_search {
  margin-bottom: 10px;
}

.date_search >>> .el-input {
  width: 120px;
}

.date_search >>> .el-input__inner,
.date_search >>> .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.item_title {
  display: inline-block;
  font-size: 14px;
  color: #4e5671;
  font-family: RCB;
  margin-right: 10px;
}

.news_source >>> .news_input {
  display: inline-block;
  width: 270px;
}

.news_source >>> .el-input__inner,
.news_source >>> .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.news {
  height: 168px;
  border-bottom: 1px solid #f3f4f5;
}

.news > div {
  display: inline-block;
  vertical-align: top;
}

.news_img {
  width: 145px;
  margin: 30px 0 15px;
  text-align: center;
}

.news_content {
  padding-top: 27px;
  width: calc(100% - 145px);
}

.img_container {
  width: 120px;
  height: 78px;
  line-height: 73px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
}

.img_container img {
  max-width: 100%;
}

.news .news_content .title {
  font-size: 18px;
  color: #9ca2b3;
  font-family: RCB;
  margin-bottom: 15px;
  cursor: pointer;
}

.news .news_content .title:hover {
  color: #4e5671;
}

.news .color_alone {
  color: #1a6bc5;
  font-family: RCR;
}
.item_detail {
  font-family: RCR;
}
.news .news_content .detail {
  font-size: 13px;
  color: #6c757d;
  line-height: 20px;
  margin-bottom: 15px;
  font-family: RCR;
}

.other_infor > div {
  display: inline-block;
  vertical-align: middle;
  font-size: 12px;
  color: #6c757d;
}

.data_list >>> .el-pagination {
  margin: 0 auto;
  text-align: center;
}
.news_source >>> .el-select > .el-input {
  width: 200px !important;
}
.date_search >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px !important;
}
.date_search >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
</style>
